// 9 homepage cards — artwork, colors & order follow reference image 1.
// Row1: Common Number | Blog | Dream Number
// Row2: Analytics | Predict Target | Previous Result
// Row3: Teer Calendar | Reputed Counters | Morning Teer

const IMG = {
  dream_number:
    "https://static.prod-images.emergentagent.com/jobs/eef0b061-a276-4b9a-a17e-75703ed13934/images/9bb3d858cf27985b65d1ec1f5de91bf12d69968ccf1e66d95c4791c3ae0e3218.jpeg",
  analytics:
    "https://static.prod-images.emergentagent.com/jobs/eef0b061-a276-4b9a-a17e-75703ed13934/images/027d8f7d7397ed82f3b03e3acdbe2cb82649cca410e77d1c57992f0d3a5766cf.jpeg",
  predict_target:
    "https://static.prod-images.emergentagent.com/jobs/eef0b061-a276-4b9a-a17e-75703ed13934/images/781fe8e2fcae1e3a9ff92c3eee8ebdf54dfc1b5fced6e3443cf0c9e13699a748.jpeg",
  previous_result:
    "https://static.prod-images.emergentagent.com/jobs/eef0b061-a276-4b9a-a17e-75703ed13934/images/2e6c77346aa3b425a5bea92b78bcd34f75fb20e1f66de8c5b192d889a89bf74e.jpeg",
  teer_calendar:
    "https://static.prod-images.emergentagent.com/jobs/eef0b061-a276-4b9a-a17e-75703ed13934/images/f4c8c6beb255e446359a03029bb8b38ca05a0689bec315e7b226864ad07ad1f7.jpeg",
  reputed_counters:
    "https://static.prod-images.emergentagent.com/jobs/eef0b061-a276-4b9a-a17e-75703ed13934/images/b1a2cf3b70baf8e0c466e2f9d4b05929dc66729ad5f7411e5eb99c579f315846.jpeg",
  morning_teer:
    "https://static.prod-images.emergentagent.com/jobs/eef0b061-a276-4b9a-a17e-75703ed13934/images/cdc08a3ea9f6c329cf075781dd9c08c9c8a3464fe7801b3e0a889efb73037959.jpeg",
};

export const CARDS = [
  {
    key: "common-number",
    title: "Common Number",
    to: "/common-number/",
    bg: "#f1584c",
    fg: "#ffffff",
    kind: "letter",
    letter: "C",
    alt: "Common Number",
    testId: "card-common-number",
  },
  {
    key: "blog",
    title: "Blog",
    to: "/blog/",
    bg: "#ffffff",
    fg: "#12324f",
    kind: "letter-outline",
    letter: "B",
    star: true,
    alt: "Blog",
    testId: "card-blog",
  },
  {
    key: "dream-number",
    title: "Dream Number",
    to: "/dream-number/",
    bg: "#f1584c",
    fg: "#ffffff",
    kind: "image",
    img: IMG.dream_number,
    alt: "Bhutan Morning Teer Dream Number",
    testId: "card-dream-number",
  },
  {
    key: "analytics",
    title: "Analytics",
    to: "/analytics/",
    bg: "#16406e",
    fg: "#ffffff",
    kind: "image",
    img: IMG.analytics,
    alt: "Bhutan Morning Teer Analytics",
    testId: "card-analytics",
  },
  {
    key: "predict-target",
    title: "Predict Target",
    to: "/predict-target/",
    bg: "#4a3f35",
    fg: "#ffffff",
    kind: "image",
    img: IMG.predict_target,
    alt: "Bhutan Morning Teer Predict Target",
    testId: "card-predict-target",
  },
  {
    key: "previous-result",
    title: "Previous Result",
    to: "/previous-result/",
    bg: "#1ab5a3",
    fg: "#ffffff",
    kind: "image",
    img: IMG.previous_result,
    alt: "Bhutan Morning Teer Previous Result",
    testId: "card-previous-result",
  },
  {
    key: "teer-calendar",
    title: "Teer Calendar",
    to: "/teer-calendar/",
    bg: "#1ab5a3",
    fg: "#ffffff",
    kind: "image",
    img: IMG.teer_calendar,
    alt: "Bhutan Morning Teer Calendar",
    testId: "card-teer-calendar",
  },
  {
    key: "reputed-counters",
    title: "Reputed Counters",
    to: "/reputed-counters/",
    bg: "#ffffff",
    fg: "#7a3b12",
    kind: "image",
    img: IMG.reputed_counters,
    alt: "Reputed Counters",
    testId: "card-reputed-counters",
  },
  {
    key: "morning-teer",
    title: "Morning Teer",
    to: "https://shillongmorningteerresulttoday.com/",
    external: true,
    bg: "#241041",
    fg: "#ffffff",
    kind: "image",
    img: IMG.morning_teer,
    alt: "Bhutan Morning Teer",
    star: true,
    testId: "card-morning-teer",
  },
];
